import { WizTranslationManager } from '@wizeoo/akm-component-lib';

/** objet comparateur (<=>, between, isNull...) */
export class ComparatorVO {
  /**
   * constructeur composite
   */
  public constructor(code: string, shortLabel: string, label: string, order: number, datakind: string[], nbParams: number = 1) {
    this.code = code;
    this.shortLabel = shortLabel;
    this.label = label;
    this.order = order;
    this.trsLabel = WizTranslationManager.getInstance().translateKey(label);
    this.fulltrsLabel = this.shortLabel + ' (' + this.trsLabel + ')';
    this.datakind = new Set(datakind);
    this.nbParams = nbParams;
  }

  code: string;
  shortLabel: string;
  label: string;
  order: number = 100;
  trsLabel: string; // label traduit
  fulltrsLabel: string; // label traduit (code)
  datakind: Set<string> = null; // type de données élégibles pour ce comparateur
  nbParams: number = 1; // nombre de paramètres (2 pour between)
  
  public get labelOrDefaultLabel(): string {
    return this.trsLabel;
  }

}
